export const environment = {
  production: true,
  googleClientId: '777914969970-tjhn68nu40pmq9stfvmdejfhm68crvgk.apps.googleusercontent.com',
  siteKey: '6LdP6NsZAAAAABhFeahuZ6nI05RVnKLJewbSBC-Q',
  googleTranslationApiKey: 'AIzaSyA0vMnMaZzWyjLcfhTcKBEASMxQPs0SDLM'
};
